// Which concrete types satisfy each interface and union in the schema.
//
// Without this map InMemoryCache cannot tell that, say, DebriefingAnswerSamples
// satisfies DebriefingAnswerInterface, so every field selected through an
// interface or union fragment is dropped on read — silently, with the query
// itself answering correctly. Spelling the concrete types out in each query
// instead works, but a 15-way union blows past the URL length this app's
// `useGETForQueries` link can send and the server answers 431.
//
// Regenerate after a schema change:
//   grep -E '^(union |interface |type \w+ implements )' schema.graphql

export const possibleTypes: Record<string, string[]> = {
  DebriefingAnswerInterface: [
    'DebriefingAnswerContacts',
    'DebriefingAnswerDate',
    'DebriefingAnswerDegree',
    'DebriefingAnswerDropdown',
    'DebriefingAnswerFileUpload',
    'DebriefingAnswerGoodBad',
    'DebriefingAnswerMultipleChoice',
    'DebriefingAnswerNumber',
    'DebriefingAnswerOpinionScale',
    'DebriefingAnswerRating',
    'DebriefingAnswerSamples',
    'DebriefingAnswerText',
    'DebriefingAnswerTextarea',
    'DebriefingAnswerTime',
    'DebriefingAnswerYesNo',
  ],
  DebriefingAnswerUnion: [
    'DebriefingAnswerText',
    'DebriefingAnswerTextarea',
    'DebriefingAnswerNumber',
    'DebriefingAnswerFileUpload',
    'DebriefingAnswerOpinionScale',
    'DebriefingAnswerSamples',
    'DebriefingAnswerContacts',
    'DebriefingAnswerMultipleChoice',
    'DebriefingAnswerDropdown',
    'DebriefingAnswerGoodBad',
    'DebriefingAnswerYesNo',
    'DebriefingAnswerTime',
    'DebriefingAnswerDate',
    'DebriefingAnswerRating',
    'DebriefingAnswerDegree',
    'type',
    'implements',
    'DebriefingAnswerInterface',
  ],
};
